<template><div><h1>VUX V2.3.8 发布日志</h1>
<h2><a href="/zh-CN/components/checker.html">Checker</a></h2>
<ul><li>[enhance] 当前选中 item 被 disabled 时清除值 #1479</li>
</ul>
<h2><a href="/zh-CN/components/checklist.html">Checklist</a></h2>
<ul><li>[feature] 支持 prop:disabled 禁用操作 #1254</li>
</ul>
<h2><a href="/zh-CN/components/inline-calendar.html">InlineCalendar</a></h2>
<ul><li>[enhance] 不可见日期不可点击 #1564</li>
</ul>
<h2><a href="/zh-CN/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[fix] 修复 iOS 低版本下 placeholder 无法显示的问题 #1293</li>
</ul>
<h2><a href="/zh-CN/components/radio.html">Radio</a></h2>
<ul><li>[feature] 支持 prop:disabled 禁用操作 #1254</li>
<li>[feature] 支持 less 变量 @radio-checked-icon-color #896</li>
</ul>
<h2><a href="/zh-CN/components/x-address.html">XAddress</a></h2>
<ul><li>[feature] 添加 slot:title，方便自定义样式 #1389</li>
</ul>
<h2><a href="/zh-CN/components/datetime.html">Datetime</a></h2>
<ul><li>[feature] 是的，Datetime 可以作为插件直接调用了</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.3.8 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.3.8-239.vue?0f3af555